/** 絶対URLかどうかを判定する */
export function isAbsoluteURL(url: string): boolean {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}

/** URLとパスを連結する */
export function combineUrls(baseURL: string, relativeURL: string): string {
  return relativeURL ? baseURL.replace(/\/+$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
}

/** URLを構築する */
export function buildFullPath(baseURL: string, requestedURL: string): string {
  if (baseURL && !isAbsoluteURL(requestedURL)) {
    return combineUrls(baseURL, requestedURL);
  }
  return requestedURL;
}

/** リクエストヘッダを構築する */
export function buildHeaders<T = HeadersInit>(headers?: T): HeadersInit {
  if (!headers) {
    // 未指定(undefined)の場合、`Content-Type: application/json` を返す
    return {
      "Content-Type": "application/json",
    };
  }

  return headers;
}

/**
 * ローカル環境以外はセキュリティのためcredentialsをデフォルト値("same-origin")とする
 * @see https://developer.mozilla.org/ja/docs/Web/API/Request/credentials
 */
export function buildCredentials(credentials?: Request["credentials"]): Request["credentials"] | undefined {
  if (process.env.NODE_ENV !== "development") {
    return undefined;
  }

  return credentials;
}

/** リクエストボディを構築する */
export function buildRequestBody<T = object>(body: T): string | FormData | null {
  // FormDataの場合、 `JSON.stringify()` せずそのまま返す
  if (body instanceof FormData) return body;

  // bodyがnull,undefinedの場合はnullを返して終了する
  // JSON.stringifyにnullを渡すとエラーになるため
  if (!body) return null;

  return JSON.stringify(body);
}

export function resolvePath<T = object>(basePath: string, paths?: T) {
  if (!paths) return basePath;

  let endpoint = basePath;
  for (const queryKey in paths) {
    const replaceValue = queryKey ? paths[queryKey] : "";
    endpoint = endpoint.replace(`{${queryKey}}`, replaceValue as string);
  }

  return endpoint;
}

/** クエリパラメータ付きのURLパスを構築する */
export function buildPathWithSearchParams<T = object>(basePath: string, params?: T) {
  // パラメータがない場合、URLパスをそのまま返す
  if (!params || Object.keys(params).length === 0) return basePath;

  for (const key in params) {
    if (params[key] === undefined) {
      // URLSearchParamsで`key="undefined"`になるので削除する
      delete params[key];
    }
  }

  const urlSearchParams = new URLSearchParams(params);
  return `${basePath}?${urlSearchParams.toString()}`;
}
